import { Row, Col } from 'antd'
import { useTranslation } from 'next-i18next'
import { webAssets } from '../../../utils/webAssets'

import ResponsiveImage from '../ResponsiveImage'
import Laptop from '../../svgs/aboutUs/Laptop'

const paragraphs = [
  "Siamo pionieri nell'utilizzo della firma elettronica avanzata, che garantisce la piena validità legale dei tuoi documenti.",
  "La nostra firma elettronica, conforme con il regolamento europeo eIDAS e con l'articolo 2702 del codice civile, offre il massimo in termini di sicurezza e affidabilità.",
  'Il suo valore probatorio è equiparabile a una firma autografa.',
  'In più, offriamo la verifica dell’identità con il riconoscimento facciale.',
]

const Technology = () => {
  const { t } = useTranslation('common')
  return (
    <div className='technology pt-28 lg:pt-60 pb-60 lg:pb-120'>
      <div className='container mx-auto'>
        <div className='flex items-center gap-8 mb-24'>
          <Laptop style='w-32' />
          <h2 className='text-[1.75rem] text-green font-semibold mb-0'>
            TECNOLOGIA
          </h2>
        </div>

        <Row justify='space-between' gutter={[24, 24]}>
          <Col
            xs={{ order: 1, span: 24 }}
            md={{ order: 1, span: 12 }}
            lg={{ order: 1, span: 14 }}
          >
            {paragraphs.map((paragraph, index) => (
              <p
                key={index}
                className='text-dimmed font-light text-xl leading-10 mb-20 last:mb-0'
              >
                {t(paragraph)}
              </p>
            ))}
          </Col>
          <Col
            xs={{ order: 2, span: 24 }}
            md={{ order: 1, span: 12 }}
            lg={{ order: 1, span: 10 }}
          >
            <ResponsiveImage
              alt='Tecnologia firma elettronica avanzata'
              src={webAssets.aboutUs3}
              width={456}
              height={272}
            />
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Technology
